import { Link } from "@tanstack/react-router";
import { Globe, Package, Palette, UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ActionEntry {
  to: string;
  i18nKey: string;
  icon: typeof Globe;
}

const ACTIONS: readonly ActionEntry[] = [
  { to: "/users", i18nKey: "dashboard.actions.new_customer", icon: UserPlus },
  { to: "/packages", i18nKey: "dashboard.actions.new_package", icon: Package },
  { to: "/branding", i18nKey: "dashboard.actions.theme_editor", icon: Palette },
  { to: "/domains", i18nKey: "dashboard.actions.verify_domain", icon: Globe },
];

export function QuickActionsPanel(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold">
          {t("dashboard.actions.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-1.5 pb-3">
        {ACTIONS.map(({ to, i18nKey, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="flex items-center gap-2 rounded-md bg-secondary/40 px-3 py-2 text-sm font-medium text-secondary-foreground transition-colors hover:bg-secondary"
          >
            <Icon className="size-4 text-primary" />
            <span>{t(i18nKey)}</span>
          </Link>
        ))}
      </CardContent>
    </Card>
  );
}
